(() => {
  if (customElements.get('sigla-image-loop')) return;
  class SiglaImageLoop extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.inView = true;
      // Start moving only after the page has finished loading, so the first paint is fast and stable.
      this.started = false;
      const start = () => setTimeout(() => { this.started = true; this.update(); }, 1200);
      if (document.readyState === 'complete') start(); else window.addEventListener('load', start, {once: true});
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      const options = {signal: this.controller.signal};
      document.addEventListener('visibilitychange', () => this.update(), options);
      this.motion.addEventListener('change', () => this.update(), options);
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting; this.update();
      }, {threshold: 0});
      this.observer.observe(this);
      this.update();
    }
    update() { this.dataset.paused = String(!this.started || !this.inView || document.hidden || this.motion.matches); }
    disconnectedCallback() { this.observer?.disconnect(); this.controller?.abort(); this.controller = null; }
  }
  customElements.define('sigla-image-loop', SiglaImageLoop);
})();
